module.exports = __webpack_public_path__ + "img/prestashop.86f726d0.png";